import { render } from "./MemberCouponList.vue?vue&type=template&id=480becc2"
import script from "./MemberCouponList.vue?vue&type=script&lang=js"
export * from "./MemberCouponList.vue?vue&type=script&lang=js"
script.render = render

export default script